<template>
    <div id="Tabs" class="text-center row">
        <div class="d-none d-md-block col-md-4">
        </div>
        <div class="col-12 col-md-4">
            <b-button :class="mainButtonClass" block to='/medicalcare'>
                <font-awesome-icon :icon="['fas', 'stethoscope']" />
                &nbsp;
                {{ this.simulationTypes.medicalCare.value }}
            </b-button>
            <b-button :class="mainButtonClass" block to='/dentalcare'>
                <font-awesome-icon :icon="['fas', 'tooth']" />
                &nbsp;
                {{ this.simulationTypes.dentalCare.value }}
            </b-button>
            <b-button :class="mainButtonClass" block to='/opticalcare'>
                <font-awesome-icon :icon="['fas', 'glasses']" />
                &nbsp;
                {{ this.simulationTypes.opticalCare.value }}
            </b-button>
            <b-button :class="mainButtonClass" block to='/hospitalization'>
                <font-awesome-icon :icon="['fas', 'hospital']" />
                &nbsp;
                {{ this.simulationTypes.hospitalization.value }}
            </b-button>
        </div>
    </div>
</template>

<script>
import  { simulationTypes }  from "../helpers/types"
import Branding from '../helpers/branding'

export default {
    computed: {
        simulationTypes: function () {
            return simulationTypes
        },
        navClass () { return 'nav flex-column flex-md-row nav-pills nav-justified ' + this.brandingClass },
        brandingClass () { return Branding.getNavClass() },
        mainButtonClass () { return Branding.getMainButtonClass() },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue